import Bowser from 'bowser'
import store from '@/Store'

window.build_versao = `${process.env.NODE_ENV.slice(0, 3).toUpperCase()}-${process.env.VUE_APP_VERSAO_BUILD}`
const getVersao = () => {
  return ''
  /**
   *  Comentado porque no Elastic o campo de Versão está esperando um FLOAT
   *  o retorno que está sendo enviado aqui é uma string e está causando conflito no mapping do elastic search.
   */
  // return `${process.env.NODE_ENV.slice(0, 3).toUpperCase()}-${process.env.VUE_APP_VERSAO_BUILD}`
}

const mshubPayload = (payload) => {
  const config = store.state.SetupApp.config
  const canal = store.state.SetupApp.canal
  const protocolo = store.state.SetupApp.protocolo
  const numeroChamado = store.state.SetupApp.numeroChamado
  const userAgentInfos = Bowser.parse(window.navigator.userAgent)
  const idFuncionalidade = store.state.SetupApp.idFuncionalidade

  return {
    negocio: { ...payload }, // payload
    sistema: {
      app: {
        bundle: config.aplicacao.bundle,
        canal: canal,
        protocolo_origem: protocolo,
        numeroChamado: numeroChamado,
        versao: getVersao(),
        versaoConfigurador: config.aplicacao.versao,
        sandbox: `${store.getters['SetupApp/instanciaAplicacao']}` === '1',
        idFuncionalidade: idFuncionalidade,
        instancia_aplicacao: store.getters['SetupApp/instanciaAplicacao']
      },
      dispositivo: {
        plataforma: userAgentInfos.os.name,
        versaoPlataforma: userAgentInfos.os.version,
        navegador: userAgentInfos.browser.name,
        versaoNavegador: userAgentInfos.browser.version
      },
      localidade: {
        latitude: undefined,
        longitude: undefined
      },
      token: {}
    }
  }
}

export default mshubPayload
